import axios from "axios"
import { URL_BASE } from '../../../config/config'
''
const RESOURCE = 'rentals/rental_monthly_fee_values'


export default {

    actions: {
        storeRentalMonthlyFeeValue(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve) => {
                axios.post(`${URL_BASE}${RESOURCE}`, params)
                    .then(response => resolve(response.data))
                    .catch(error => console.log(error))
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

        destroyRentalMonthlyFeeValue(context, id){
            context.commit('PRELOADER', true)
            return new Promise((resolve, reject) => {
                axios.delete(`${URL_BASE}${RESOURCE}/${id}`)
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
                    //.finally(() => context.commit('PRELOADER', false))    
            })
            
        },

        massStoreRentalMonthlyFeeValue(context, params) {
            context.commit('PRELOADER', true)
            return new Promise((resolve) => {
                axios.get(`${URL_BASE}rentals/rental_monthly_fee_value_mass_store`, {params})
                    .then(response => resolve(response.data))
                    .catch(error => console.log(error))
                    .finally(() => context.commit('PRELOADER', false))
            })
        },

    },

    getters: {

    }

}